import { Box } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { GroupProps } from "react-virtuoso";
import { useGroupedVirtualizedContext } from "./context";

export const VirtuosoGroup = forwardRef(function VirtuosoGroup<D>(
  { children, ...props }: GroupProps,
  ref?: Ref<HTMLDivElement>
) {
  const { slotProps } = useGroupedVirtualizedContext();

  return (
    <Box {...props} {...slotProps?.group} ref={ref}>
      {children}
    </Box>
  );
});
